var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.21 90.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #33495c;\n      }\n\n      .cls-3 {\n        fill: #f6ca5e;\n      }\n\n      .cls-4 {\n        fill: #3f5969;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m42.81,65.46c1.33-4.44,3.99-8.43,7.54-11.53,6.65-5.54,10.87-13.97,10.87-23.28C61.21,13.34,46.8-.85,29.06.04,13.31.7.45,14.01,0,29.75c-.22,9.76,3.99,18.41,10.87,24.17,3.77,3.1,6.43,7.1,7.76,11.53h24.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m27.73,65.9h2l-8.87-33.04h.67c1.11,0,2.22-.44,3.1-1.33.44-.44.89-.67,1.55-.67s1.11.22,1.55.67c1.55,1.77,4.21,1.77,5.77,0,.44-.44.89-.67,1.55-.67.44,0,1.11.22,1.55.67.89.89,1.77,1.33,3.1,1.33h.67l-8.65,33.04h2l9.09-34.59c0-.44,0-.89-.44-1.11-.44-.22-.89,0-1.11.22-.44.44-.89.67-1.33.67-.67,0-1.11-.22-1.77-.67-.89-.89-1.77-1.33-2.88-1.33s-2,.44-2.88,1.33-2.22.89-3.1,0c-.67-.89-1.77-1.33-2.88-1.33h0c-1.11,0-2.22.44-2.88,1.33-.44.44-1.11.67-1.77.67-.44,0-1.11-.22-1.33-.67-.22-.22-.67-.44-1.11-.22-.44.22-.67.67-.44,1.11l8.87,34.59Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m23.74,85.86c1.11,2.66,3.77,4.66,6.87,4.66s5.77-2,6.87-4.66h-13.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m38.82,86.08h-16.19c-2.22,0-3.99-1.77-3.99-3.99v-16.85h24.17v16.85c0,2.22-1.77,3.99-3.99,3.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m42.59,73.66h-23.95c-1.33,0-2.44-1.11-2.44-2.44h0c0-1.33,1.11-2.44,2.44-2.44h23.95c1.33,0,2.44,1.11,2.44,2.44h0c0,1.33-1.11,2.44-2.44,2.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m42.59,81.42h-23.95c-1.33,0-2.44-1.11-2.44-2.44h0c0-1.33,1.11-2.44,2.44-2.44h23.95c1.33,0,2.44,1.11,2.44,2.44h0c0,1.33-1.11,2.44-2.44,2.44Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.e936ec568f93f586227bab2b772696db.svg";
export { ForwardRef as ReactComponent };